export enum PAGING_DIRECTION {
  ASC = 'ASC',
  DESC = 'DESC',
}
